import { ofType } from 'redux-observable';
import { merge, of } from 'rxjs';
import {
  switchMap,
  withLatestFrom,
  catchError,
  mergeMap,
} from 'rxjs/operators';

import { toApiBankAccount } from '../../mappers';
import {
  SUBMIT_BANK_ACCOUNT_FORM,
  genericSubmit,
  genericSubmitError,
  genericSubmitSuccess,
  submitBankAccountFormError,
  submitBankAccountFormSuccess,
} from '../../actions';
import { contextSelector } from '../../selectors';

const createUrl = (state) => {
  const { activeJourneyId } = contextSelector(state);

  return `/gateway-server/journeys/${activeJourneyId}/bank`;
};

export default (action$, state$, { ajax }) =>
  action$.pipe(
    ofType(SUBMIT_BANK_ACCOUNT_FORM),
    withLatestFrom(state$),
    switchMap(([{ payload }, state]) =>
      merge(
        of(genericSubmit()),
        ajax({
          useAuth: true,
          method: 'POST',
          url: createUrl(state),
          body: toApiBankAccount(payload),
        }).pipe(
          mergeMap(() =>
            of(submitBankAccountFormSuccess(payload), genericSubmitSuccess())
          ),
          catchError((e) =>
            of(submitBankAccountFormError(e), genericSubmitError())
          )
        )
      )
    )
  );
